import React from "react";
import Avatar from "@material-ui/core/Avatar";

const tabConfig = [
  {
    columnTitle: "",
    dataField: ["component"],
    component: ({ values }) => {
      return <Avatar src={values.backgroundImageURL} variant="rounded" />;
    },
  },
  {
    columnTitle: "Title",
    dataField: ["name"],
  },
  {
    columnTitle: "Description",
    dataField: ["description"],
  },
  {
    columnTitle: "Position",
    dataField: ["position"],
  },
];

export const questionTabConfig = [
  {
    columnTitle: "Options",
    dataField: ["options.length"],
  },
  {
    columnTitle: "Question",
    dataField: ["question"],
  },
  {
    columnTitle: "Type",
    dataField: ["type"],
  },
];
export default tabConfig;
